import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import authService from './api-authorization/AuthorizeService';

interface TruckToolChecklist {
    loading: boolean;
    errors: any;
    vehicles: GenericList[];
    truckId: number;
    truckName: string;
    toolCheckOptions: GenericList[];
    team: GenericList[];
    truckToolCheck: TruckToolCheck;
    timeOfDay: number;
}

interface TruckToolCheck {
    id: number;
    drillKit: number;
    drillKitNote: string;
    drillBit: number;
    drillBitNote: string;
    truckTools: number;
    truckToolsNote: string;
    staticTruckItems: number;
    staticTruckItemsNote: string;
    notes: string;
    checkCompletedById: number;
}

interface GenericList {
    id: number;
    name: string;
}

interface INameToValueMap {
    [key: string]: any;
}

export class TruckToolChecklistData extends React.Component<RouteComponentProps<{}>, TruckToolChecklist> {
    constructor(props: any) {
        super(props);

        this.state = {
            loading: true,
            errors: {},
            vehicles: [],
            team: [],
            truckId: 0,
            truckName: "",
            toolCheckOptions: [],
            timeOfDay: 1,
            truckToolCheck: {
                id: 0,
                drillKit: -1,
                drillKitNote: "",
                drillBit: -1,
                drillBitNote: "",
                truckTools: -1,
                truckToolsNote: "",
                staticTruckItems: -1,
                staticTruckItemsNote: "",
                notes: "",
                checkCompletedById: -1
            }
        };
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        //get whether it is first or last tool check
        let userParams: INameToValueMap = {};
        userParams["timeofday"] = 0;
        userParams["truckId"] = -1;
        userParams = this.props.match.params;
        let timeOfDay = userParams["timeofday"];
        if (!timeOfDay) { timeOfDay = 1; }
        let truckId = userParams["truckId"];
        if (!truckId) { truckId = -1; }

        this.getData(truckId, timeOfDay);
    }

    async getData(truckId: number, timeOfDay: number) {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/Job/GetTruckToolCheckGroupedData?TruckId=' + truckId + '&TimeOfDay=' + timeOfDay + '&SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            this.setState({ timeOfDay: res.data.truckToolCheck.timeOfDay, toolCheckOptions: res.data.toolCheckOptions, truckToolCheck: res.data.truckToolCheck, vehicles: res.data.vehicles, team: res.data.team, truckId: res.data.truckId, truckName: res.data.truckName, loading: false });
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    back = (e: any) => {
        e.preventDefault();
        this.props.history.push("/driverjobs");
    }

    handleChange = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let truckToolCheck = this.state.truckToolCheck;
        let change: any = {};
        change = truckToolCheck;
        change[e.target.name] = e.target.value * 1;
        if (e.target.value * 1 === 1) {
            //clear the notes
            change[e.target.name + "Note"] = "";
        }
        this.setState({ truckToolCheck: change, errors: errors })
    }

    handleChangeText = (e: any) => {
        //check if there is a value and an error, and if so remove from error list
        var errors = this.state.errors;
        if (e.target.value) {
            delete errors[e.target.name];
        }

        let truckToolCheck = this.state.truckToolCheck;
        let change: any = {};
        change = truckToolCheck;
        change[e.target.name] = e.target.value;
        this.setState({ truckToolCheck: change, errors: errors })
    }

    handleTruckChange = (e: any) => {
        //get check list for new truck
        var truckId = e.target.value * 1;
        this.getData(truckId, this.state.timeOfDay);
    }

    validate = () => {
        let fields = this.state.truckToolCheck;
        let errors: any = {};
        let formIsValid = true;

        if (!fields.checkCompletedById || fields.checkCompletedById <= 0) {
            formIsValid = false;
            errors["checkCompletedById"] = "Person Completing Check is required";
        }

        if (!fields.drillKit || fields.drillKit <= 0) {
            formIsValid = false;
            errors["drillKit"] = "Drill Kit is required";
        }

        if (!fields.drillBit || fields.drillBit <= 0) {
            formIsValid = false;
            errors["drillBit"] = "Drill Bits are required";
        }

        if (!fields.truckTools || fields.truckTools <= 0) {
            formIsValid = false;
            errors["truckTools"] = "Truck Tools are required";
        }

        if (!fields.staticTruckItems || fields.staticTruckItems <= 0) {
            formIsValid = false;
            errors["staticTruckItems"] = "Static Truck Items are required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = (e: any) => {
        e.preventDefault();

        if (this.validate()) {
            this.saveTruckToolCheck();
        }
    }

    async saveTruckToolCheck() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        var truckToolCheck = this.state.truckToolCheck;

        var saveTruck = {
            truckId: this.state.truckId,
            truckName: this.state.truckName,
            subId: user.sub,
            timeOfDay: this.state.timeOfDay,
            truckToolCheck: truckToolCheck
        };

        //add new contact
        axios.post('api/Job/SaveTruckToolCheckGrouped', saveTruck, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            if (res.data.isError) {
                var errors = res.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                toast.success("Truck Tool Checklist has been saved");
                this.props.history.push("/driverjobs");
            }
        })
        .catch(error => {
            toast.error(error.message);
        });
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        var truckOptions = this.state.vehicles;
        var truckCount = truckOptions.length;
        var truckCheck = this.state.truckToolCheck;
        var toolCheckOptions = this.state.toolCheckOptions;

        return (
            <div>
                <div className="mobileFont marginTop70 marginBottom10">
                    <div className="makeitflexspacebetween marginBottom10">
                        <h2 className="mobile-margin">Truck Tool Check</h2>
                        <a className="mobile-icon-grey" href="#" onClick={(e) => this.back(e)}>
                            <span className="fas fa-arrow-alt-circle-left mobileMenuSize alignIconCenter"></span>
                        </a>
                    </div>

                    <span className="hidden">Truck Id: {truckCheck.id}</span>
                    <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="truckFilterId">
                        <span className="label-mobile--inline-md margin5">Truck</span>
                        <select className="select margin5" id="truckId" name="truckId" value={this.state.truckId} onChange={(e) => this.handleTruckChange(e)} disabled={truckCount <= 1}>
                            <option hidden defaultValue="-1"></option>
                            {truckOptions.map(truck =>
                                <option key={truck.id} value={truck.id}>{truck.name}</option>
                            )};
                        </select>
                    </label>

                    <div className={this.state.truckId <= 0 && truckOptions.length === 0 ? "" : "hidden"}>
                        <span className="makeitred">There are no jobs allocated to you for today!</span>
                    </div>
                    <div className={this.state.truckId <= 0 ? "hidden" : ""}>
                        <label className="input-group makeitflexspacebetween truckcheck-background jobcheck-border" htmlFor="checkCompletedById">
                            <span className="label-mobile--inline-md margin5">Person Completing Checks</span>
                            <div className="marginRight10">
                                {this.state.team.map(item =>
                                    <div className="input-group alignitemscentre" key={item.id}>
                                        <input type="radio" className="marginRight10" id={item.name} name="checkCompletedById" value={item.id} checked={truckCheck.checkCompletedById === item.id} onChange={(e) => this.handleChange(e)}></input>
                                        <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                    </div>)
                                }
                            </div>
                        </label>
                        <span className={this.state.errors["checkCompletedById"] ? "label errors" : "hidden"}>{this.state.errors["checkCompletedById"]}</span>
                        <hr></hr>

                        <h4>Drill Kit</h4>
                        <div className="driverjobs-tools-border marginBottom10">
                            <div className="makeitflex marginLeft5">
                                <div className="driverjobs-tools-itemwidth">
                                    <div>2 x Impact Drivers</div>
                                    <div>1 x Impact Wrench</div>
                                    <div>1 x Cordless Drill</div>
                                    <div>4 x Batteries</div>
                                    <div>1 x Charger</div>
                                    <div>1 x 125mm Hole Saw & Arbour</div>
                                    <div>1 x 13mm Drill Bit</div>
                                </div>
                                <div className="driverjobs-tools-locwidth">
                                    {toolCheckOptions.map(item =>
                                        <div className="input-group alignitemscentre" key={item.id}>
                                            <input type="radio" className="marginRight10" id={item.name} name="drillKit" value={item.id} checked={truckCheck.drillKit === item.id} onChange={(e) => this.handleChange(e)}></input>
                                            <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={truckCheck.drillKit === 2 || truckCheck.drillKit === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                                <hr></hr>
                                <label className="input-group" htmlFor="drillKitNote">
                                    <span className="label-mobile--inline-md makeitbold">Drill Kit Notes</span>
                                    <input className="input--mobile margin5" maxLength={200} type="text" id="drillKitNote" name="drillKitNote" value={truckCheck.drillKitNote} onChange={(e) => this.handleChangeText(e)}></input>
                                </label>
                            </div>
                        </div>
                        <span className={this.state.errors["drillKit"] ? "label errors" : "hidden"}>{this.state.errors["drillKit"]}</span>

                        <h4>Drill Bits</h4>
                        <div className="driverjobs-tools-border marginBottom10">
                            <div className="makeitflex marginLeft5">
                                <div className="driverjobs-tools-itemwidth">
                                    <div>3 x Rail Bits (18mm Cut Socket)</div>
                                    <div>3 x 1/2* Rail Bit Adapters (min)</div>
                                    <div>2 x 5/16 Tek Bit (Short)</div>
                                    <div>1 x 5/16 Tek Bit (Long)</div>
                                    <div>2 x Bugle Bit</div>
                                    <div>1 x Phillips Head Screw Driver Bit</div>
                                </div>
                                <div className="driverjobs-tools-locwidth">
                                    {toolCheckOptions.map(item =>
                                        <div className="input-group alignitemscentre" key={item.id}>
                                            <input type="radio" className="marginRight10" id={item.name} name="drillBit" value={item.id} checked={truckCheck.drillBit === item.id} onChange={(e) => this.handleChange(e)}></input>
                                            <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={truckCheck.drillBit === 2 || truckCheck.drillBit === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                                <hr></hr>
                                <label className="input-group" htmlFor="drillBitNote">
                                    <span className="label-mobile--inline-md makeitbold">Drill Bits Notes</span>
                                    <input className="input--mobile margin5" maxLength={200} type="text" id="drillBitNote" name="drillBitNote" value={truckCheck.drillBitNote} onChange={(e) => this.handleChangeText(e)}></input>
                                </label>
                            </div>
                        </div>
                        <span className={this.state.errors["drillBit"] ? "label errors" : "hidden"}>{this.state.errors["drillBit"]}</span>
                        
                        <h4>Truck Tools</h4>
                        <div className="driverjobs-tools-border marginBottom10">
                            <div className="makeitflex marginLeft5">
                                <div className="driverjobs-tools-itemwidth">
                                    <div>1 x Hammer</div>
                                    <div>1 x Shifter</div>
                                    <div>1 x Tape Measure</div>
                                    <div>1 x Hand Saw</div>
                                    <div>1 x Stanley Knife</div>
                                    <div>1 x Tie Wire</div>
                                    <div>1 x Carry Tottie</div>
                                    <div>1 x Strap Tensioner</div>
                                    <div>1 x Strap Crimper</div>
                                    <div>1 x Tin Snip</div>
                                    <div>1 x Pinch Bar / Crowbar</div>
                                    <div>1 x Tool Belt for Screws</div>
                                </div>
                                <div className="driverjobs-tools-locwidth">
                                    {toolCheckOptions.map(item =>
                                        <div className="input-group alignitemscentre" key={item.id}>
                                            <input type="radio" className="marginRight10" id={item.name} name="truckTools" value={item.id} checked={truckCheck.truckTools === item.id} onChange={(e) => this.handleChange(e)}></input>
                                            <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={truckCheck.truckTools === 2 || truckCheck.truckTools === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                                <hr></hr>
                                <label className="input-group" htmlFor="truckToolsNote">
                                    <span className="label-mobile--inline-md makeitbold">Truck Tools Notes</span>
                                    <input className="input--mobile margin5" maxLength={200} type="text" id="truckToolsNote" name="truckToolsNote" value={truckCheck.truckToolsNote} onChange={(e) => this.handleChangeText(e)}></input>
                                </label>
                            </div>
                        </div>
                        <span className={this.state.errors["truckTools"] ? "label errors" : "hidden"}>{this.state.errors["truckTools"]}</span>

                        <h4>Static Truck Items</h4>
                        <div className="driverjobs-tools-border marginBottom10">
                            <div className="makeitflex marginLeft5">
                                <div className="driverjobs-tools-itemwidth">
                                    <div>2 x Harnesses</div>
                                    <div>1 x Harness M/R Bracket</div>
                                    <div>1 x Extension Ladder</div>
                                    <div>1 x Step Ladder</div>
                                    <div>8 x Truck Binders</div>
                                    <div>2 x Hand Binders</div>
                                    <div>4 x Traffic Cones</div>
                                    <div>1 x First Aid Kit</div>
                                </div>
                                <div className="driverjobs-tools-locwidth">
                                    {toolCheckOptions.map(item =>
                                        <div className="input-group alignitemscentre" key={item.id}>
                                            <input type="radio" className="marginRight10" id={item.name} name="staticTruckItems" value={item.id} checked={truckCheck.staticTruckItems === item.id} onChange={(e) => this.handleChange(e)}></input>
                                            <span className="makeitflex makeitcentervertical marginRight10">{item.name}</span>
                                        </div>
                                    )}
                                </div>
                            </div>
                            <div className={truckCheck.staticTruckItems === 2 || truckCheck.staticTruckItems === 3 ? "marginLeft5 marginBottom10" : "hidden"}>
                                <hr></hr>
                                <label className="input-group" htmlFor="staticTruckItemsNote">
                                    <span className="label-mobile--inline-md makeitbold">Static Truck Item Notes</span>
                                    <input className="input--mobile margin5" maxLength={200} type="text" id="staticTruckItemsNote" name="staticTruckItemsNote" value={truckCheck.staticTruckItemsNote} onChange={(e) => this.handleChangeText(e)}></input>
                                </label>
                            </div>
                        </div>
                        <span className={this.state.errors["staticTruckItems"] ? "label errors" : "hidden"}>{this.state.errors["staticTruckItems"]}</span>

                        <label className="input-group" htmlFor="notes">
                            <span className="label-mobile makeitbold">Additional Notes</span>
                            <p>Add any additional notes that may be required based on the choices you have made.</p>
                            <textarea className="input job__noteSize label-mobile" id="notes" name="notes" value={truckCheck.notes} onChange={(e) => this.handleChangeText(e)}></textarea>
                        </label>

                        <div className="defaultbutton__container--right marginTop10">
                            <a className="mobile-icon-green" href="#" onClick={(e) => this.save(e)}>
                                <span className="fas fa-circle-check mobileMenuSize alignIconCenter"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        );

    }
}
